import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCommon from './zh/common.json';
import zhLogin from './zh/login.json';
import zhSettings from './zh/settings.json';
import zhProjectList from './zh/projectList.json';
import zhProjectDetail from './zh/projectDetail.json';
import zhEpisodeDetail from './zh/episodeDetail.json';
import zhAdmin from './zh/admin.json';
import zhConfig from './zh/config.json';
import zhTickets from './zh/tickets.json';
import zhNotifications from './zh/notifications.json';
import zhSkills from './zh/skills.json';
import zhProfile from './zh/profile.json';
import zhScriptSummary from './zh/scriptSummary.json';
import enCommon from './en/common.json';
import enLogin from './en/login.json';
import enSettings from './en/settings.json';
import enProjectList from './en/projectList.json';
import enProjectDetail from './en/projectDetail.json';
import enEpisodeDetail from './en/episodeDetail.json';
import enAdmin from './en/admin.json';
import enConfig from './en/config.json';
import enTickets from './en/tickets.json';
import enNotifications from './en/notifications.json';
import enSkills from './en/skills.json';
import enProfile from './en/profile.json';
import enScriptSummary from './en/scriptSummary.json';

const NAMESPACES = ['common', 'login', 'settings', 'projectList', 'projectDetail', 'episodeDetail', 'admin', 'config', 'tickets', 'notifications', 'skills', 'profile', 'scriptSummary'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: { common: zhCommon, login: zhLogin, settings: zhSettings, projectList: zhProjectList, projectDetail: zhProjectDetail, episodeDetail: zhEpisodeDetail, admin: zhAdmin, config: zhConfig, tickets: zhTickets, notifications: zhNotifications, skills: zhSkills, profile: zhProfile, scriptSummary: zhScriptSummary },
      en: { common: enCommon, login: enLogin, settings: enSettings, projectList: enProjectList, projectDetail: enProjectDetail, episodeDetail: enEpisodeDetail, admin: enAdmin, config: enConfig, tickets: enTickets, notifications: enNotifications, skills: enSkills, profile: enProfile, scriptSummary: enScriptSummary },
    },
    fallbackLng: 'zh',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    ns: [...NAMESPACES],
    defaultNS: 'common',
  });

export default i18n;
